/** Growth Platforms Technology contact details, shared by the launcher and /about. */
export const CONTACT_EMAIL = 'usgrowthplatformstechnology@deloitte.com';

export interface Contact {
  name: string;
  role: string;
  email: string;
  initials: string;
  askAbout: string;
}

export const CONTACTS: readonly Contact[] = [
  {
    name: 'Matt Garland',
    role: 'GP Technology Leader',
    email: 'mgarland@deloitte.com',
    initials: 'MG',
    askAbout: 'Platform vision, the AI Spine roadmap, and new app ideas.',
  },
  {
    name: 'Alex Lockey',
    role: 'GP Technology Program Lead',
    email: 'alockey@deloitte.com',
    initials: 'AL',
    askAbout: 'Onboarding, timelines, and getting your app live.',
  },
];
